import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_PAGINATOR_DEFAULT_OPTIONS } from '@angular/material/paginator';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TitleStrategy } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AppRoutingModule } from './app-routing.module';
import { authInterceptor } from './auth/auth.interceptor';
import { CustomErrorHandler } from './custom-error-handler';
import { NavComponent } from './nav/nav.component';
import { encodingInterceptor } from './shared/interceptors/encoding.interceptor';
import { loggerInterceptor } from './shared/interceptors/logger.interceptor';
import { retryInterceptor } from './shared/interceptors/retry.interceptor';
import { versionInterceptor } from './shared/interceptors/version.interceptor';
import { AppDateAdapter, MY_DATE_FORMATS } from './shared/providers/app-date-adapter';
import { ACHIEVE_DIALOG_DEFAULT_OPTIONS } from './shared/providers/dialog-default-options';
import { AchieveConfigService } from './shared/services/achieve-config-service/achieve-config.service';
import { AchieveTitleStrategy } from './shared/services/page-title/achieve-title-strategy';

function initApp(achieveConfigService: AchieveConfigService) {
  return async () => {
    await achieveConfigService.load();
  };
}

@NgModule({
  imports: [AppRoutingModule, NavComponent, AngularSvgIconModule.forRoot()],
  providers: [
    AchieveConfigService,
    provideAppInitializer(() => {
      const initializerFn = initApp(inject(AchieveConfigService));
      return initializerFn();
    }),
    provideHttpClient(withInterceptors([retryInterceptor, authInterceptor, loggerInterceptor, encodingInterceptor, versionInterceptor])),
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    { provide: Window, useValue: window },
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: ACHIEVE_DIALOG_DEFAULT_OPTIONS },
    { provide: MAT_PAGINATOR_DEFAULT_OPTIONS, useValue: { formFieldAppearance: 'fill' } },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { hideRequiredMarker: true } },
    { provide: TitleStrategy, useClass: AchieveTitleStrategy },
    provideAnimations(),
  ],
  bootstrap: [],
})
export class AppModule {
  constructor() {}
}
